import axios from 'axios';
import { API_URL } from '../config';

// Client dedicato al funnel pubblico di consulenza busta paga: nessun
// token di autenticazione, queste chiamate sono pensate per un utente
// anonimo.
const client = axios.create({ baseURL: API_URL });

export async function getCcnlDisponibili() {
  const { data } = await client.get('/sindacato/ccnl');
  return data.ccnl;
}

export async function getCcnlDettaglio(ccnlId, data) {
  const params = data ? { data } : {};
  const res = await client.get(`/sindacato/ccnl/${ccnlId}`, { params });
  return res.data;
}

export async function estraiCedolino(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await client.post('/extract-pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function caricaCedolino({ questionario, cedolino, consensoAccettato }) {
  const { data } = await client.post('/sindacato/pubblico/cedolini', {
    questionario,
    cedolino,
    consenso_trattamento: { accettato: consensoAccettato },
  });
  return data;
}

export async function richiediContattoOperatore(cedolinoId, { nome, recapito }) {
  const { data } = await client.post(`/sindacato/pubblico/cedolini/${cedolinoId}/contatto`, {
    accettato: true,
    nome,
    recapito,
  });
  return data;
}

export async function revocaContattoOperatore(cedolinoId) {
  const { data } = await client.post(`/sindacato/pubblico/cedolini/${cedolinoId}/contatto/revoca`);
  return data;
}
